export default __webpack_public_path__ + "static/media/head02_vi_pc@2x.a68af3a1.png";